import {getRowDataForColumnComponent} from 'js/common/griddle_column_helper';
import React from 'react';

const Product = props => {
    const {product_name, product_description} = getRowDataForColumnComponent(props);

    return (
        <div>
            <div>{product_name}</div>
            <div className="small">{product_description}</div>
        </div>
    );
};

export default Product;



// WEBPACK FOOTER //
// ./admin_operations/shipping/components/product.js